import styled from "styled-components";
import { motion } from "framer-motion";

export const ResumenContainer = styled(motion.div)`
  width: 100%;
  height: calc(100dvh - 25dvh);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 14px;
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }
`;

export const ResumenMensajes = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 27px;
  margin-top: 25px;
  margin-bottom: 20px;
  .resumenmensajes-titulo {
    color: var(--color-latex10);
    line-height: 150%;
  }
  .resumenmensajes-mensaje {
    color: var(--color-latex10);
  }
  span {
    text-align: center;
  }
`;

export const ResumenBotones = styled.div`
  width: max-content;
  height: max-content;
  margin: auto;
  padding-top: 50px;
  @media (max-height: 700px) {
    padding-bottom: 50px;
    padding-top: 30px;
  }
`;
